'use strict';

var cache = {};
var rules = [];

var insert = function insert(rule) {
  return rules.push(rule);
};

var css = function css(rule) {
  if (cache[rule]) return;
  insert(rule);
  cache[rule] = true;
};

css.css = function () {
  return rules.join('');
};

css.reset = function () {
  cache = {};

  while (rules.length) {
    rules.pop();
  }
};

if (typeof document !== 'undefined') {
  var sheet = document.head.appendChild(document.createElement('style')).sheet;

  insert = function insert(rule) {
    rules.push(rule);
    sheet.insertRule(rule, sheet.cssRules.length);
  };
}

module.exports = css;